







































































import FeedbackComponent from '@/components/base/FeedbackComponent'
import AccountDetailsTab
  from "@/components/dashboard/find-member-or-employer/tabs/searchEmployee/modalTabs/AccountDetailsTab.component.vue";
import ArrearsAlertTab
  from "@/components/dashboard/find-member-or-employer/tabs/searchEmployee/modalTabs/ArrearsAlertTab.component.vue";
import PolicyDetailsTab
  from "@/components/dashboard/find-member-or-employer/tabs/searchEmployee/modalTabs/PolicyDetailsTab.component.vue";
import ReportsTab
  from "@/components/dashboard/find-member-or-employer/tabs/searchEmployee/modalTabs/ReportsTab.component.vue";
import {StoreNamespace} from '@/globals/StoreNamespaceGlobal'
import {ManagingCompanies} from "@/models/ManagingCompanies";
import {ExportType} from '@payroll/grid-widget/src/models/ExportType'
import {GridColumn} from '@payroll/grid-widget/src/models/GridColumn'
import {BaseRequest} from '@payroll/optimus-common'
import {FieldType, SearchFieldModel} from '@payroll/search-results-widget/src/models/SearchField.model'
import Component from 'vue-class-component'
import {Prop} from 'vue-property-decorator'
import {Action, Getter} from 'vuex-class'

@Component({
  components: {
    AccountDetailsTab,
    PolicyDetailsTab,
    ReportsTab,
    ArrearsAlertTab
  }
})
export default class SearchEmployeeForEmployer extends FeedbackComponent {

  @Prop() private insuranceSearch!: boolean
  @Prop(Number) private employerId!: number

  private searchFields: SearchFieldModel[] = []
  private columns: GridColumn[] = []
  private showModal: boolean = false
  private employeeDetailsData: any = {}
  private memberIdNum!: string
  private memberName!: string
  private employerNum!: number
  private authorizedTabs: any = []
  private title!: string


  @Action('searchEmployee', StoreNamespace.CUSTOMER_SERVICE) searchEmployee: any
  @Action('getEmployeeDetails', StoreNamespace.CUSTOMER_SERVICE) getEmployeeDetails: any
  @Action('getEmployeeCardTabs', StoreNamespace.CUSTOMER_SERVICE) getEmployeeCardTabs: any
  @Action('exportEmployees', StoreNamespace.CUSTOMER_SERVICE) exportEmployees: any

  @Getter('mngCompanyName', StoreNamespace.AUTHENTICATION) mngCompanyName!: string

  created() {
    this.title = this.insuranceSearch ? 'search_insurance' : 'search_employee'
  }

  mounted() {


    this.searchFields.push({
      label: this.insuranceSearch ? 'insurance_name' : 'member_name',
      property: 'memberName',
      fieldType: FieldType.TEXT_FIELD,
      maxLength: 150
    });
    this.searchFields.push({
      label: 'id_number',
      property: 'idNumber',
      fieldType: FieldType.TEXT_FIELD,
      maxLength: 16
    })
    this.searchFields.push({
      label: this.getAccountNumLabel(),
      property: 'accountNumber',
      fieldType: FieldType.TEXT_FIELD,
      maxLength: 30
    })
    this.searchFields.push({
      label: 'employer_name',
      property: 'employerName',
      fieldType: FieldType.TEXT_FIELD,
      advancedOnly: true,
      maxLength: 100
    })
    this.searchFields.push({
      label: 'employer_number',
      property: 'employerNum',
      fieldType: FieldType.NUMBER_FIELD,
      advancedOnly: true,
      maxValue: 999999999
    })

    if (!this.insuranceSearch) {
      this.searchFields.push({
        label: 'agent_number',
        property: 'agentNumber',
        fieldType: FieldType.NUMBER_FIELD,
        advancedOnly: true,
        maxValue: 99999999999
      })
    }

    if (this.insuranceSearch) {
      this.searchFields.push({
        label: 'activeNotActive',
        property: 'isActive',
        fieldType: FieldType.SELECT_FIELD,
        selectOptions: [{
          value: 'true',
          description: '' + this.$t('yes')
        }, {
          value: 'false',
          description: '' + this.$t('no')
        }],
        selectDisplay: 'description',
        unSelectFirst: true,
        advancedOnly: true
      })
    }

    this.initColumns()
    this.getEmployeeCardTabs({requestorCallback: this})
  }

  private getAccountNumLabel() {
    let accountNumLabel = this.insuranceSearch ? 'policy_number' : 'account_number';
    if (this.isGilad) {
      accountNumLabel = 'program_number';
    }
    return accountNumLabel;
  }

  private initColumns(): void {
    this.columns.push({
      property: 'idNumber',
      header: 'id_num',
      widthInPoints: 50
    } as GridColumn)
    this.columns.push({
      property: 'memberName',
      header: this.insuranceSearch ? 'insurance_name' : 'member_name'
    } as GridColumn)
    if (!this.insuranceSearch) {
      this.columns.push({
        property: 'fundNum',
        header: 'fund'
      } as GridColumn)
    }
    this.columns.push({
      property: 'accountNumber',
      header: this.getAccountNumLabel()
    } as GridColumn)
    if (this.insuranceSearch) {
      this.columns.push({
        property: 'accountStatus',
        header: 'status_policy',
        widthInPoints: 50
      } as GridColumn)
    }
    this.columns.push({
      property: 'employerNumber',
      header: 'employer_number',
      widthInPoints: 50
    } as GridColumn)
    this.columns.push({property: 'employerName', header: 'employer_name'} as GridColumn)
    if (!this.insuranceSearch) {
      this.columns.push({property: 'agentNumber', header: 'agent_number'} as GridColumn)
    }
  }

  searchEmployees(searchObject: any) {
    searchObject.employerId = this.employerId

    this.searchEmployee({
      requestBody: searchObject as BaseRequest,
      requestorCallback: this
    })
  }

  onProgress(requestName?: string): void {
    this.loading = true
    if (requestName !== 'findMembersOrEmployersFor/exportEmployees') {
      this.$Progress.start();
    }
  }

  onSuccess(data?: any, requestName?: any, message?: any) {
    if (requestName === 'findMembersOrEmployersFor/searchEmployees') {
      this.$emit('successResults', data)
    } else if (requestName === 'findMembersOrEmployersFor/exportEmployees') {
      this.$emit('successExport', data)
    } else if (requestName === 'findMembersOrEmployersFor/getEmployeeDetails') {
      this.employeeDetailsData = data
    } else if (requestName === 'findMembersOrEmployersFor/getEmployeeCardTabs') {
      this.authorizedTabs = data
    }
  }

  openEmployeeModal(result: any) {
    if (result.idNumber) {
      this.memberIdNum = result.idNumber
      this.memberName = result.memberName
      this.employerNum = result.employerNumber
      this.getEmployeeDetails({
        requestBody: {
          id: result.id,
          idNumber: this.memberIdNum
        },
        requestorCallback: this
      })
      this.showModal = true
      this.$emit('toggleScrollbar')
    }
  }

  exportEmployeesGrid(exportType: ExportType, gridColumns: Array<GridColumn>, searchObject: any): void {
    searchObject.employerId = this.employerId

    this.exportEmployees({
      requestBody: {
        headerText: this.exportFileName,
        exportType: exportType,
        columnsList: gridColumns,
        searchObject: searchObject
      } as BaseRequest,
      requestorCallback: this
    })
  }

  get exportFileName(): string {
    return '' + this.$t(this.insuranceSearch ? 'search_insured' : 'search_employee')
  }

  get isLoggedInMngCompanyIsNotGilad(): boolean {
    return !this.mngCompanyName.includes(ManagingCompanies.GILAD.toLowerCase())
  }

  get isGilad(): boolean {
    return this.mngCompanyName.includes(ManagingCompanies.GILAD.toLowerCase())
  }

  get isNotInfinityGemel(): boolean {
    return !this.mngCompanyName.includes(ManagingCompanies.INFINITY_GEMEL.toLowerCase())
  }
}
